var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmSofaBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77778 8.61719C3.24927 8.61719 3.70146 8.80459 4.03486 9.13817C4.36825 9.47175 4.55556 9.92419 4.55556 10.3959V12.1747H13.4444V10.3959C13.4444 9.92419 13.6317 9.47175 13.9651 9.13817C14.2985 8.80459 14.7507 8.61719 15.2222 8.61719C15.6937 8.61719 16.1459 8.80459 16.4793 9.13817C16.8127 9.47175 17 9.92419 17 10.3959V13.9535C17 14.4252 16.8127 14.8776 16.4793 15.2112C16.1459 15.5448 15.6937 15.7322 15.2222 15.7322H2.77778C2.30628 15.7322 1.8541 15.5448 1.5207 15.2112C1.1873 14.8776 1 14.4252 1 13.9535V10.3959C1 9.92419 1.1873 9.47175 1.5207 9.13817C1.8541 8.80459 2.30628 8.61719 2.77778 8.61719Z",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77783 8.61502V4.16813C2.77783 3.4605 3.05878 2.78185 3.55888 2.28148C4.05898 1.78111 4.73725 1.5 5.4445 1.5H12.5556C13.2629 1.5 13.9411 1.78111 14.4412 2.28148C14.9413 2.78185 15.2223 3.4605 15.2223 4.16813V8.61502",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 15.7227V17.5004",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3315 15.7227V17.5004",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmSofaBig);
export default __webpack_public_path__ + "static/media/crm-sofa-big.2eafc093c459ade95661449fb321a905.svg";
export { ForwardRef as ReactComponent };